import React from 'react';

export const Settings = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-6">Settings</h2>
      <p className="text-gray-600">Customize your preferences and account settings.</p>
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded">Change Password</button>
    </div>
  );
};